export enum TodistusRatkaisuType {
  RATKAISTU = 'RATKAISTU', // RatkaisuType.RATKAISTU
  RAUENNUT = 'RAUENNUT', // RatkaisuType.RAUENNUT
  SILLENSA_JATETTY = 'SILLENSA_JATETTY', // RatkaisuType.SILLENSA_JATETTY
  KIELTEINEN_PAATOS = 'KIELTEINEN_PAATOS', // RatkaisuType.KIELTEINEN_PAATOS
  HYLATTY = 'HYLATTY', // RatkaisuType.KIELTEINEN_PAATOS
  AIHEETON_VIENTI = 'AIHEETON_VIENTI', // RatkaisuType.AIHEETON_VIENTI
  ASIAN_SIIRTO = 'ASIAN_SIIRTO', // Ratkaisutype.ASIAN_SIIRTO
  AUTOMAATTISESTI_KASITELTY = 'AUTOMAATTISESTI_KASITELTY', // RatkaisuType.AUTOMAATTISESTI_KASITELTY
}
